import { render, staticRenderFns } from "./InlineTagInput.vue?vue&type=template&id=cba7ea10&scoped=true"
import script from "./InlineTagInput.vue?vue&type=script&lang=js"
export * from "./InlineTagInput.vue?vue&type=script&lang=js"
import style0 from "./InlineTagInput.vue?vue&type=style&index=0&id=cba7ea10&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba7ea10",
  null
  
)

export default component.exports